import { Trans } from 'react-i18next';
import { Button, ButtonColor } from 'components/uikit/buttons/Button';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import styles from './DeleteItemModal.module.scss';
import {
  BaseNode,
  getAllDescendants,
  isFile,
  isFolder,
  NodeType,
} from 'helpers/documents/types/base';
import { VariableDocumentList } from 'pages/authorized/variables/components/variableDocumentsList/VariableDocumentsList';
import { isDocument } from 'helpers/documents/types/documents';

type DeleteItemModalProps = {
  item: BaseNode;
  onClose: () => void;
  onDelete: () => Promise<void>;
  projectId?: number;
  revisionId?: number;
};

export const DeleteItemModal: React.FC<DeleteItemModalProps> = (props) => {
  const buttonTitle = useScopedTranslation('Button.Title');

  let modalMessage:
    | 'message_folder'
    | 'message_document'
    | 'message_template'
    | 'message_folder_with_files';

  const nestedFiles = isFolder(props.item)
    ? getAllDescendants(props.item).filter(isFile)
    : null;

  switch (props.item.type) {
    case NodeType.Folder:
      modalMessage =
        nestedFiles && nestedFiles.length > 0
          ? 'message_folder_with_files'
          : 'message_folder';
      break;
    case NodeType.Document:
      modalMessage = 'message_document';
      break;
    case NodeType.Template:
      modalMessage = 'message_template';
      break;
    default:
      throw new Error('DeleteItemModal: Unsupported item type');
  }

  return (
    <div>
      <div>
        <div className={styles.message}>
          <Trans
            i18nKey={`Component.DeleteItemModal.${modalMessage}`}
            values={{ itemName: props.item.name }}
            components={{
              red: <span className={styles.danger} />,
            }}
          />
          {nestedFiles && nestedFiles.length > 0 && (
            <VariableDocumentList
              documents={nestedFiles.map((n) => ({
                id: isDocument(n) ? n.documentId : parseInt(n.id, 10),
                name: n.name,
                revisionVersion: null,
                projectId: props.projectId,
                revisionId: props.revisionId!,
              }))}
            />
          )}
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          title={buttonTitle.t('cancel')}
          color={ButtonColor.Secondary}
          className={styles.button}
          onClick={async () => {
            props.onClose();
          }}
        />
        <Button
          type={'submit'}
          title={buttonTitle.t('delete')}
          color={ButtonColor.DestroyPrimary}
          className={styles.button}
          onClick={async () => {
            await props.onDelete();
            props.onClose();
          }}
        />
      </div>
    </div>
  );
};
